import { parseAsString, useQueryState } from "nuqs";

// Keep the raw string: an invalid parameter must not silently become create mode.
export const useInspectionUrl = () =>
	useQueryState("inspection", parseAsString.withOptions({ history: "push" }));
